import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import * as i1 from '@angular/common/http';
let TranslateHttpLoader = /*#__PURE__*/(() => {
  class TranslateHttpLoader {
    http;
    prefix;
    suffix;
    constructor(http, prefix = "/assets/i18n/", suffix = ".json") {
      this.http = http;
      this.prefix = prefix;
      this.suffix = suffix;
    }
    /**
     * Gets the translations from the server
     */
    getTranslation(lang) {
      return this.http.get(`${this.prefix}${lang}${this.suffix}`);
    }
    static ɵfac = function TranslateHttpLoader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || TranslateHttpLoader)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(String), i0.ɵɵinject(String));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: TranslateHttpLoader,
      factory: TranslateHttpLoader.ɵfac
    });
  }
  return TranslateHttpLoader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TranslateHttpLoader };
